export default __webpack_public_path__ + "static/media/FECHAS_10.be8e3284.png";